import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { Button } from "semantic-ui-react";
import { FilterContext } from "../FilterContext";
import { initialVisibleFilter } from "./FilterTypes/VisibleFilterType";

interface VisibilityFilterProps {
  title?: string
  onlyVisibleLabel?: string
  onlyNotVisibleLabel?: string
}

const VisibilityFilter = (props: VisibilityFilterProps) => {
  const title = props.title || RESX.GeneralLabels.Visible;
  const onlyNotVisibleLabel = props.onlyNotVisibleLabel || RESX.GeneralLabels.NotVisible;
  const onlyVisibleLabel = props.onlyVisibleLabel || RESX.GeneralLabels.Visible;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);

  register("visible", {
    getTitle: () => title,
    renderSelection: (filter) => <>
      {filter.visibility === "onlyVisible" ? onlyVisibleLabel : undefined}
      {filter.visibility === "onlyNotVisible" ? onlyNotVisibleLabel : undefined}
    </>,
    hasValue: (filter) => filter.visibility !== "noFilter",
    reset: () => ({
      visibility: "noFilter"
    }),
    areEqual: (a, b) => a.visibility === b.visibility
  });

  useEffect(() => {
    setInitialValue("visible", initialVisibleFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [visibility, setVisibility] = React.useState<server.dto.VisibleFilterSettings>(initialVisibleFilter.visibility);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setVisibility(getValue("visible").visibility);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("visible", { visibility });
    setPopupOpen(false);
  };

  const options: Array<{ value: server.dto.VisibleFilterSettings, label: string }> = [
    { value: "onlyVisible", label: onlyVisibleLabel },
    { value: "onlyNotVisible", label: onlyNotVisibleLabel }
  ];
  type Option = typeof options[number];

  const onChange = (option: Option) => {
    setVisibility(option.value);
    setValue("visible", { visibility: option.value });
    onPopupClose();
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<form onSubmit={onApply}>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={options}
            selectedItems={[options.find(v => v.value === visibility)].filter(Boolean)}
            onItemToggled={onChange}
            getId={opt => opt.value.toString()}
            getName={opt => opt.label}
          />
        </div>

        <Button fluid type="submit" primary >
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default VisibilityFilter;